import { render, staticRenderFns } from "./BusinessClientList.vue?vue&type=template&id=371b30f2&scoped=true&"
import script from "./BusinessClientList.vue?vue&type=script&lang=ts&"
export * from "./BusinessClientList.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessClientList.vue?vue&type=style&index=0&id=371b30f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b30f2",
  null
  
)

export default component.exports